import React, { useEffect, useState } from "react";
import Header from "../../common/Header";
// import Sidebar from "../../common/Sidebar - Copy";
import Sidebar from "../../common/Sidebar";
import Footer from "../../common/Footer";
import axios from 'axios';
import { getToken, triggerAlert } from '../../utils'
import Loader from "../../common/Loader";
import DashboardSectionOne from "./DashboardSectionOne";
// import DashboardSectionTwo from "./DashboardSectionTwo";
import CountUp from 'react-countup';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
function Dashboard() {
    document.title = "AutoSdlc - Dashboard"
    const api_url = process.env.REACT_APP_API_BASE_URL;
    const api = process.env.REACT_APP_CUSTURL;
    const token = Cookies.get('admin_user_token');
    const [isLoading, setIsLoading] = useState(false);
    const [dashboardCounts, setDashboardCounts] = useState(null);
    const navigate = useNavigate();
    const fetchData = async () => {
        // setIsLoading(true);
        try {
            const response = await axios.get(api_url + `dashboard/get_dashboard_count`, token);

            const response_data = response.data;
            // console.log('response_dataCards', response_data);

            if (response_data.error_code === 200) {
                const itemsArray = response_data.results.data
                // console.log('status', dashboardCounts.ticket_data[0].status)
                setDashboardCounts(itemsArray);
                // setIsLoading(false);
            } else if (response.status === 204) {
                setDashboardCounts([]);
                // setIsLoading(false);
            } else {
                triggerAlert('error', 'Oops...', "Couldn't get the card details");
            }
        } catch (error) {
            // setIsLoading(false);
            triggerAlert("error", "Oops...", "Something went wrong..");
        }
    };

    useEffect(() => {
        // fetchData();
        getcustomerlist()
        // alert('I am called')
    }, [])
    const [customercount, setcustomercount] = useState([])
    const getcustomerlist = async () => {
        try {
            const response = await axios.get(`/apiV1/dashboard/customer_status_count`);
            if (response.data) {
                let results = response.data;
                setcustomercount(results)


            }
        } catch (error) {
            console.log("not found");

        }
    };

    const [openticketsview, setopenticketsview] = useState({})
    const [totallist, settotallist] = useState([{}])
    useEffect(() => {

        getcustomerlist1()
    }, [])
    const getcustomerlist1 = async () => {
        try {
            const response = await axios.get(`/apiV1/dashboard/get_dashboard_count`);
            if (response.data) {
                let results = response.data.results;
                setopenticketsview(results)


            }
        } catch (error) {
            console.log("not found");

        }
    };




    return (
        <>
            <div id="layout-wrapper">

                <Header />
                <Sidebar />

                {/* <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== --> */}
                <div className="main-content">

                    <div className="page-content" style={{ backgroundColor: "#ededed" }}>
                        <div className="container-fluid" style={{boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",padding: "15px",borderRadius: "10px",marginBottom:"10px",backgroundColor:"#fff"}}>

                            {/* <!-- start page title --> */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0 font-size-18">Dashboard</h4>

                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                {/* <!-- <li className="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                                            <li className="breadcrumb-item active">Horizontal</li> --> */}
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                                          <div className="row gap-0">
                {/* Container for the first three cards */}
                <div className="col-xxl-6 col-xl-6 col-lg-6">
                  <div className="row">
                    {/* <div className="col-12">
                                            <h4 className="card-title mb-3 flex-grow-1 card-title-custom">
                                                Customer status
                                            </h4>
                                        </div> */}

                    <div className="col-xxl-12 col-xl-12 col-lg-12 pt-4 p-4">
                      <div className="row border dash-row">
                        <h4 className="card-title mb-4 flex-grow-1 card-title-custom">
                          Customer status
                        </h4>



                        <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <div className="card card-outer">
                            <div className="card-header dash-card">
                              <div className="row align-items-center">
                                <div className="col-xxl-4 col-xl-3 col-lg-3 col-md-12 col-sm-12">
                                  <div className="toll-free IconContainer dash-main">
                                    <div className="dash-icon avatar-md">
                                      <i
                                        className="fa fa-user-plus"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                               
                                <div className="col-xxl-8 col-xl-9 col-lg-9 col-md-12 col-sm-12">
                                  <div>
                                    <div className="d-flex align-items-center justify-content-between">

                                    <h4 className="text-left mt-3">
                                      {customercount.total_customers}
                                    </h4>
                                    <svg width="24" className="mt-2" height="24" fill="none" stroke="#7fad19" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 7 7 17"></path>
                                    <path d="M8 7h9v9"></path>
                                    </svg>
                                    </div>
                                    <h4 className="card-title mb-0 flex-grow-1 text-org pb-2 text-left dash-text">
                                      Total Customer
                                    </h4>
                                  </div>
                                </div>

                                {/* <div className="col-12">
                                  
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <div className="card card-outer">
                            <div className="card-header dash-card2">
                              <div className="row align-items-center">
                                <div className="col-4">
                                  <div className="toll-free IconContainer dash-main">
                                    <div className="dash-icon2 avatar-md">
                                      <i
                                        className="fa fa-users"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-8">
                                  <div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="text-left mt-3">
                                        {customercount.total_active_cust}
                                        </h4>
                                        <svg width="24" className="mt-2" height="24" fill="none" stroke="#085e91" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 7 7 17"></path>
                                        <path d="M8 7h9v9"></path>
                                        </svg>
                                    </div>

                                    <h4 className="card-title mb-0 flex-grow-1 text-org pb-2 text-left dash-text">
                                    Active Customer
                                    </h4>
                                  </div>
                                </div>
                               
                               
                               
                              </div>
                            </div>
                          </div>
                        </div>


                        <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <div className="card card-outer">
                            <div className="card-header dash-card3">
                              <div className="row align-items-center">
                                <div className="col-4">
                                  <div className="toll-free IconContainer dash-main">
                                    <div className="dash-icon3 avatar-md">
                                      <i
                                        className="fa fa-user-times"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-8">
                                  <div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="text-left mt-3">
                                        {customercount.total_inactive_cust}
                                        </h4>
                                        <svg width="24" className="mt-2" height="24" fill="none" stroke="#e86a3a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 7 7 17"></path>
                                        <path d="M8 7h9v9"></path>
                                        </svg>
                                    </div>


                                    <h4 className="card-title mb-0 flex-grow-1 text-org pb-2 text-left dash-text">
                                    Inactive Customer
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>

                {/* Container for the next three cards */}

                <div className="col-xxl-6 col-xl-6 col-lg-6">
                  <div className="row">
                    {/* <div className="col-12">
        <h4 className="card-title mb-3 flex-grow-1 card-title-custom">
            Customer status
        </h4>
    </div> */}

                    <div className="col-xxl-12 col-xl-12 col-lg-12 pt-4 p-4">
                      <div className="row border dash-row">
                        <h4 className="card-title mb-4 flex-grow-1 card-title-custom">
                          Ticket status
                        </h4>


                        <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <div className="card card-outer">
                            <div className="card-header dash-card4">
                              <div className="row align-items-center">
                                <div className="col-4">
                                <div className="toll-free IconContainer dash-main">
                                  <div className="dash-icon4 avatar-md">
                                    <i
                                      className="fa fa-hourglass-start fns-12 "
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                </div>
                                </div>

                                <div className="col-8">
                                  <div>
                                  <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="text-left mt-3">
                                        {openticketsview.Open}
                                        </h4>
                                        <svg width="24" className="mt-2" height="24" fill="none" stroke="#f9cd36" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 7 7 17"></path>
                                        <path d="M8 7h9v9"></path>
                                        </svg>
                                    </div>
                                  <h4 className="card-title mb-0 flex-grow-1 text-org pb-2 text-start dash-text">
                                    Open Ticket
                                  </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>



                        
                        <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <div className="card card-outer">
                            <div className="card-header dash-card5">
                              <div className="row align-items-center">
                                <div className="col-4">
                                  <div className="toll-free IconContainer dash-main">
                                    <div className="dash-icon5 avatar-md">
                                      <i
                                        className="fa fa-hourglass-half fns-12 "
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-8">
                                  <div>

                                  <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="text-left mt-3">
                                        {openticketsview.Pending}
                                        </h4>
                                        <svg width="24" className="mt-2" height="24" fill="none" stroke="#2ab57d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 7 7 17"></path>
                                        <path d="M8 7h9v9"></path>
                                        </svg>
                                    </div>
                                  <h4 className="card-title mb-0 flex-grow-1 text-org pb-2 text-start dash-text">
                                    In Progress
                                  </h4>
                                  </div>
                                </div>
                                
                               
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <div className="card card-outer">
                            <div className="card-header dash-card6">
                              <div className="row align-items-center justify-content-center">
                                <div className="col-4">
                                  <div className="toll-free IconContainer dash-main">
                                    <div className="dash-icon6 avatar-md">
                                      <i
                                        className="fa fa-hourglass-end fns-12 "
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-8">
                                  <div>

                                  <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="text-left mt-3">
                                        {openticketsview.Closed}
                                        </h4>
                                        <svg width="24" className="mt-2" height="24" fill="none" stroke="#74788d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17 7 7 17"></path>
                                        <path d="M8 7h9v9"></path>
                                        </svg>
                                    </div>
                                  <h4 className="card-title mb-0 flex-grow-1 text-org pb-2 text-start dash-text">
                                    Close Ticket
                                  </h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                            {/* <!-- end row--> */}
                            <DashboardSectionOne />
                            {/* <DashboardSectionTwo /> */}


                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}

                    <Footer />
                </div>
                {/* <!-- end main content--> */}
            </div>
            {/* <!-- END layout-wrapper --> */}

            {/* <!-- Right bar overlay--> */}
            <div className="rightbar-overlay"></div>
        </>
    );
}

export default Dashboard;